import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { notifyError, notifySuccess } from '@config/tostifyConfig/tostifyConfig';
import { generatePDFFromTemplate } from '@utils/pdfGenerator';
import HrInformationHeading from './HrInformationHeading';
import HrInformationBody from './HrInformationBody';
import { buildHrInformationReportExecution } from '../services/hrInformationReportService';
import {
    handleHrInformationAccessError,
    useHrInformationPermissionCheck,
} from '../hooks/useHrInformation';

export default function HrInformation() {
    const { t } = useTranslation();
    const [selectedReport, setSelectedReport] = useState('');
    const [formState, setFormState] = useState({});
    const [executeLoading, setExecuteLoading] = useState(false);

    useHrInformationPermissionCheck();

    const handleExecute = useCallback(async () => {
        try {
            setExecuteLoading(true);
            const { reportService, reportConfig } = buildHrInformationReportExecution(selectedReport, formState);
            const result = await reportService();
            const reportData = result?.reportData ?? result;
            const config = result?.reportConfig ?? reportConfig;
            await generatePDFFromTemplate(reportData, config);
            notifySuccess('PDF отчет генериран успешно!');
        } catch (error) {
            console.error('Error executing HR information report:', error);
            if (!handleHrInformationAccessError(error)) {
                const errorMessage = error?.response?.data?.message || error?.message || t('common.errorMessage');
                notifyError(errorMessage);
            }
        } finally {
            setExecuteLoading(false);
        }
    }, [formState, selectedReport, t]);

    return (
        <div className="flex-column width-50 gap-10">
            <HrInformationHeading
                selectedReport={selectedReport}
                onReportChange={setSelectedReport}
                onExecute={handleExecute}
                executeLoading={executeLoading}
            />
            <HrInformationBody
                selectedReport={selectedReport}
                onFormStateChange={setFormState}
            />
        </div>
    );
}
